export const EBalanceUpdateTrxType = {
  "0": "UNKNOWN",
  "1": "PAGE_GET",
  "2": "PAYMENT_TAKE",
  "3": "PAYMENT_CALLBACK",
  "4": "COMMISSION_DETECT",
  "-1": "ALL"
};

export const EPayCommissionType = {
  "0": "UNKNOWN",
  "1": "RATIO",
  "2": "CONSTANT",
  "-1": "ALL"
};